// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AdminAccessCodeRequest } from './admin-access-code-request';

/** See com.rev360.pms.api.controller.admin.general.location.AdminPracticeLocationPhrRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminPracticeLocationPhrRequest extends GandalfModelBase {

	@GandalfSubRequestLabel('PHR Access Code')
	@GandalfLabel('PHR Access Code')
	@GandalfValidator({ notNull: { message: 'PHR Access Code is required' } })
	@GandalfArray(AdminAccessCodeRequest)
	accessCodes!: AdminAccessCodeRequest[];

	@GandalfLabel('Patients can place Contact Lens orders through the PHR')
	@GandalfValidator({ notNull: { message: 'Patients can place Contact Lens orders through the PHR is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	allowContactLensOrdering!: boolean;

	@GandalfLabel('Existing patients can schedule appointments through the PHR')
	@GandalfValidator({ notNull: { message: 'Existing patients can schedule appointments through the PHR is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	allowPhrScheduling!: boolean;

	@GandalfLabel('Newly registered patients can schedule appointments through the PHR')
	@GandalfValidator({ notNull: { message: 'Newly registered patients can schedule appointments through the PHR is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	allowRegisterPhrScheduling!: boolean;

	@GandalfLabel('Available for Messaging')
	@GandalfValidator({ notNull: { message: 'Available for Messaging is required' } })
	@GandalfArray(Number)
	availableForMessagingEmployeeIds!: number[];

	@GandalfLabel('PHR Patient Order Notifications')
	@GandalfArray(Number)
	patientOrderNotificationPersonIds!: number[] | null;

	@GandalfLabel('PHR Patient Schedule Notifications')
	@GandalfArray(Number)
	patientScheduleNotificationPersonIds!: number[] | null;

	@GandalfLabel('PHR Patient Update Notifications')
	@GandalfArray(Number)
	patientUpdateNotificationPersonIds!: number[] | null;

	@GandalfLabel('PHR Logo')
	@GandalfProperty({ designType: Number })
	phrLogoFileId!: number | null;

	@GandalfConstantDecorator(constants.PhrShipToType)
	@GandalfLabel('Default Ship To')
	@GandalfValidator({ notNull: { message: 'Default Ship To is required' } })
	@GandalfProperty({ designType: constants.PhrShipToType, isRequired: true })
	phrShipToType!: constants.PhrShipToType;

	@GandalfLabel('PHR URL Code')
	@GandalfValidator({ sizeString: { message: 'PHR URL Code cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	phrUrlCode!: string | null;

	@GandalfLabel('PHR Primary Color')
	@GandalfProperty({ designType: Number })
	primaryColor!: number | null;

	@GandalfLabel('PHR Registration Notifications')
	@GandalfArray(Number)
	registrationNotificationPersonIds!: number[] | null;

	@GandalfLabel('PHR Registration Schedule Notifications')
	@GandalfArray(Number)
	registrationScheduleNotificationPersonIds!: number[] | null;

	@GandalfLabel('Shipping Fee')
	@GandalfValidator({ notNull: { message: 'Shipping Fee is required' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number, isRequired: true })
	shippingFee!: number;

	@GandalfLabel('PHR Text Color')
	@GandalfProperty({ designType: Number })
	textColor!: number | null;

}
